var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:{
[`btn-${_vm.type}`]: true,
  'btn-block': _vm.block,
  'btn-lg': _vm.large,
  'btn-loading': _vm.loading
},attrs:{"type":_vm.nativeType,"disabled":_vm.loading},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }